'use strict';

var ProductListPaginationState = require('./hpe.productlist.pagination.model');
var HitsSelectModel = require('./hpe.productlist.utilitybar.hitselect.model');

/**
 * Product List Utility Bar Model
 */
module.exports = ProductListPaginationState.extend({

    /**
     * state properties
     */
    props: {
        'specsUIVisible': ['boolean', false, true],
        'specsVisible': 'boolean',
        'paginationUIVisible': ['boolean', false, true],
        'labelShowSpecs': 'string',
        'labelResults': 'string'
    },

    /**
     * derived properties
     */
    derived: {
        specsAnalytics: {
            deps: ['specsVisible'],
            fn: function() {
                return (this.specsVisible) ? 'hide' : 'show';
            }
        }
    },

    children: {
        hitsSelect: HitsSelectModel
    }
});
